import { DEFAULT_FONT } from '../../../../../constants/playerConfigurationsConstant';

import { PLAYER_IFRAME_ID } from '../../../../../constants/scenarioConstant';

export const transformOrigin = ({ target }) => {
	// edit origin
	const { width: svgWidth, height: svgHeight, x, y } = target.getBBox();

	const centerPoint = {
		x: x + svgWidth - svgWidth / 2,
		y: y + svgHeight - svgHeight / 2,
	};
	target.style.transformOrigin = `${centerPoint.x}px ${centerPoint.y}px`;
};

export const updateRotation = (currentRotation, { target }) => {
	currentRotation &&
		currentRotation[0] &&
		(target.style.transform = target.style.transform.replace(/rotate\((.*)deg\)/, currentRotation[0]));
};

export const isEventMessageComeFromEditorPlayer = (eventMessage) => {
	return document.getElementById(PLAYER_IFRAME_ID).contentWindow === eventMessage.source;
};

// A widget set to the 'Default' font follows the player's own font rather than naming a
// family, which is expressed as inheritance. In this editor preview that resolves to the
// portal's font - the real player font is only known at playback time.
export const getFontFamily = (font) => (font === DEFAULT_FONT ? 'inherit' : `${font}, Arial, sans-serif`);

export const getDropShadowStyle = (style) => {
	const { dropShadowX, dropShadowY, dropShadowBlur, dropShadowColor, dropShadowOpacity, hoverDropShadowX, hoverDropShadowY, hoverDropShadowBlur, hoverDropShadowColor, hoverDropShadowOpacity } = style;

	// box-shadow
	const dropShadow = `${dropShadowX}px ${dropShadowY}px${dropShadowBlur ? ` ${dropShadowBlur}px` : ''}${dropShadowColor ? ` rgba(${parseInt(dropShadowColor.slice(1, 3), 16)}, ${parseInt(dropShadowColor.slice(3, 5), 16)}, ${parseInt(dropShadowColor.slice(5, 7), 16)}, ${dropShadowOpacity ?? 1})` : ''}`.trim();
	const hoverDropShadow = `${hoverDropShadowX ?? dropShadowX}px ${hoverDropShadowY ?? dropShadowY}px${(hoverDropShadowBlur ?? dropShadowBlur) ? ` ${hoverDropShadowBlur ?? dropShadowBlur}px` : ''}${(hoverDropShadowColor ?? dropShadowColor) ? ` rgba(${parseInt((hoverDropShadowColor ?? dropShadowColor).slice(1, 3), 16)}, ${parseInt((hoverDropShadowColor ?? dropShadowColor).slice(3, 5), 16)}, ${parseInt((hoverDropShadowColor ?? dropShadowColor).slice(5, 7), 16)}, ${hoverDropShadowOpacity ?? dropShadowOpacity ?? 1})` : ''}`.trim();
	return {
		dropShadow: dropShadow || 'none',
		hoverDropShadow: hoverDropShadow,
	};
}

// Background opacity (stored 0-100) as a 0-1 number, defaulting to fully opaque.
// MUST be applied on an SVG <g> (group opacity), NEVER on the foreignObject's HTML
// content: a CSS `opacity` on HTML inside a foreignObject promotes it to a compositing
// layer that Safari/WebKit displaces or drops (renders at the wrong position/size, or
// invisible) - Chrome composites it correctly, so it only breaks on Safari. Apply it on
// a NON-animated ancestor <g> (not the animated shape <g>, whose opacity fade/zoom
// keyframes would clobber it).
export const getWidgetOpacity = (backgroundSettings, isHover) => {
	const { backgroundOpacity, hoverBackgroundOpacity } = backgroundSettings || {};
	const raw = isHover ? (hoverBackgroundOpacity ?? backgroundOpacity) : backgroundOpacity;
	if (raw === undefined || raw === null || raw === '') { return 1; }
	const n = Number(raw);
	return Number.isNaN(n) ? 1 : n / 100;
};

export const getBorderStyle = (style) => {
	const { borderWidth, borderType, borderColor, borderOpacity, hoverBorderWidth, hoverBorderType, hoverBorderColor, hoverBorderOpacity } = style;
	const borderColorWithOpacity = borderColor && borderColor !== 'transparent'
		? `rgba(${parseInt(borderColor.slice(1, 3), 16)}, ${parseInt(borderColor.slice(3, 5), 16)}, ${parseInt(
				borderColor.slice(5, 7),
				16,
		  )}, ${borderOpacity ?? 1})`
		: borderColor;
	const hoverBorderColorWithOpacity = hoverBorderColor && hoverBorderColor !== 'transparent'
		? `rgba(${parseInt(hoverBorderColor.slice(1, 3), 16)}, ${parseInt(
				hoverBorderColor.slice(3, 5),
				16,
		  )}, ${parseInt(hoverBorderColor.slice(5, 7), 16)}, ${hoverBorderOpacity ?? 1})`
		: hoverBorderColor;
	const border = `${borderWidth ? `${borderWidth}px` : '0px'} ${(borderType ?? "").toLowerCase()} ${borderColorWithOpacity}`.trim();
	const hoverBorder = `${`${hoverBorderWidth ?? borderWidth ?? 0}px`} ${(hoverBorderType ?? borderType ?? "").toLowerCase()} ${hoverBorderColorWithOpacity ?? borderColorWithOpacity}`.trim();
	return {
		border,
		hoverBorder,
	};
}